import {
  enableProdMode,
  isDevMode,
  provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import {
  provideTanStackQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { apiAuthInterceptor } from './app/interceptors/api-auth.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { defineCustomElements as jeepPhotoviewer } from 'jeep-photoviewer/loader';
import { TINYMCE_SCRIPT_SRC as TINYMCE_SCRIPT_SRC_TOKEN } from '@tinymce/tinymce-angular';
import { TINYMCE_SCRIPT_SRC } from './app/features/mce-editor/tinymce.constants';
import { register } from 'swiper/element/bundle';
import { watchThemeColor } from './app/utils/sync-theme-color';
import { responsiveNavAnimation } from './app/utils/responsive-nav-animation';
import { providePostHogErrorHandler } from './app/features/analytics/posthog-error-handler';
register();
defineCustomElements(window);
jeepPhotoviewer(window);
if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
  providers: [
    { provide: TINYMCE_SCRIPT_SRC_TOKEN, useValue: TINYMCE_SCRIPT_SRC },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      useSetInputAPI: true,
      mode: 'ios',
      backButtonText: 'Indietro',
      navAnimation: responsiveNavAnimation,
    }),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([apiAuthInterceptor])),
    provideTranslateService({
      fallbackLang: 'it',
      lang: 'it',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideTanStackQuery(new QueryClient()),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withComponentInputBinding(),
      withPreloading(PreloadAllModules),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:5000',
    }),
    providePostHogErrorHandler(),
  ],
}).then(() => {
  watchThemeColor();
  requestAnimationFrame(() => {
    document.documentElement.classList.add('app-ready');
  });
});
